import BaseModal, { BaseModalProps } from "../BaseModal/index";

export interface VLNoActionModalProps extends BaseModalProps {}

const VLNoActionModal = ({
  headers,
  isOpen,
  children,
  className,
  variant = "info",
  onClose,
}: VLNoActionModalProps) => {
  return (
    <BaseModal
      className={className}
      variant={variant}
      isOpen={isOpen}
      headers={headers}
      footer={null}
      onClose={onClose}
    >
      {children}
    </BaseModal>
  );
};

export default VLNoActionModal;
